import { MenuItem } from '@chakra-ui/react'
import { FC, useCallback, useMemo, useRef, useState } from 'react'
import CsvDownloader from 'react-csv-downloader'
import { GrDocumentCsv } from 'react-icons/gr'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'

import useParametrizationCurveExecutation from '@hook/parametrization/use-curve-executation'
import useTools from '@hook/shared/use-tools'

import { parseParametrizatioCurveExecutationData } from '@helper/grid/parametrization-curve'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'

const ActionExcelCurveExecutationExport: FC<ILayoutToolsExportAction> = ({
  headers,
  // eslint-disable-next-line unused-imports/no-unused-vars
  parser = parseParametrizatioCurveExecutationData
}) => {
  const { isDisabled } = useTools()
  const { data } = useParametrizationCurveExecutation()
  const [, setDisabled] = useState(false)
  const [, updateDataNew] = useImmer<any[]>([])
  const csvDownload = useRef(null)
  const columns = useMemo(() => {
    const data: any[] = []

    for (const header of headers!) {
      if (!header.columns) continue

      for (const column of header.columns) {
        if (column.show) {
          data.push({
            id: column.id,
            displayName: `${header.group} - ${column.name}`
          })
        }
      }
    }

    return data
  }, [headers])

  const rows = useMemo(() => {
    const parsedData = data

    const body = []

    for (const row of parsedData) {
      const item: any = {}

      for (const column of columns) {
        if (column.id === 'compra-desejada') {
          if (/[a-zA-Z]/.test(row[column.id])) {
            item[column.id] = row[column.id].substring(1)
          } else {
            item[column.id] = Number(row[column.id])
          }
        } else if (column.id === 'recomendacao-tipo-alerta') {
          item[column.id] = row[column.id].substring(1)
        } else {
          item[column.id] = row[column.id]
        }
      }

      body.push(item)
    }

    return body
  }, [columns, data])

  const dataFetch = useCallback(async () => {
    try {
      Swal.fire({
        title: 'Exportar dados!',
        html: 'Aguarde um momento<b></b>.',
        timerProgressBar: true,
        timer: 99999,
        didOpen: () => {
          Swal.showLoading()
        }
      })

      updateDataNew(data)
      setDisabled(true)
      Swal.close()
      csvDownload.current.handleClick()
    } catch (error: any) {}
  }, [updateDataNew, data])
  return (
    <>
      {isDisabled ? (
        <>
          <MenuItem
            p="2px 12px"
            fontSize="sm"
            bgColor="white"
            _hover={{ bg: 'gray.400' }}
            isDisabled={isDisabled}
            onClick={dataFetch}
            icon={<GrDocumentCsv />}
          >
            <CsvDownloader
              filename={'Curva-Execucao'}
              columns={columns}
              datas={rows}
              ref={csvDownload}
              text="Exportar para Tabela"
              separator=";"
              wrapColumnChar='"'
              bom={true}
            ></CsvDownloader>
          </MenuItem>
        </>
      ) : (
        <MenuItem
          p="2px 12px"
          fontSize="sm"
          bgColor="white"
          _hover={{ bg: 'gray.400' }}
          onClick={dataFetch}
          icon={<GrDocumentCsv />}
        >
          <CsvDownloader
            filename={'Curva-Execucao'}
            columns={columns}
            datas={rows}
            ref={csvDownload}
            text="Exportar para Tabela"
            separator=";"
            wrapColumnChar='"'
            bom={true}
          ></CsvDownloader>
        </MenuItem>
      )}
    </>
  )
}

export default ActionExcelCurveExecutationExport
